import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export async function setDepositSchedule(
	leadId,
	depositSchedule,
	depositIndex
) {
	console.log('setDepositSchedule', depositSchedule, leadId);
	var depRef =
		leadId &&
		firebaseRef.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/depositSchedule'
		);
	if (depositIndex) {
		// depositIndex: 0, 1, 2 ....
		// depositScheudle: 'nsf', 'cleared', ''

		depRef.child(depositIndex).update({
			status: depositSchedule,
		});
	} else {
		depRef.update(depositSchedule);
	}
}
